import React from 'react';

const SuperCropOne: React.FunctionComponent = (props) => (
    <svg
        width="61px"
        height="80px"
        viewBox="0 0 40 80"
        data-testid="ttd-super-crop-one"
        {...props}
    >
        <defs>
            <circle id="supercrop-path-1" cx="40" cy="40" r="40" />
        </defs>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-19.000000, 0.000000)">
                <mask id="mask-2" fill="white">
                    <use xlinkHref="#supercrop-path-1" />
                </mask>
                <path
                    d="M17,80 C26.8245231,63.1874144 32.7485663,47.2931287 34.7721297,32.3171429 C34.7721297,32.3171429 9.28383334,0.772244159 34.7721297,-12.1971472 C60.260426,-25.1665386 65.0948582,10.0692591 62.6776421,28.1866455 C62.6776421,28.1866455 73.3246986,36.8600727 80,39.3556587 C80,39.3556587 80,47.2071024 80,62.9099899 C68.3182226,57.7245383 60.907229,53.788732 57.7670191,51.102571 C57.7670191,51.102571 49.3184372,75.9707584 46.6161198,80 C46.6161198,80 36.7440799,80 17,80 Z"
                    fill="#000000"
                    mask="url(#mask-2)"
                />
            </g>
        </g>
    </svg>
);

export default SuperCropOne;
